import { render, staticRenderFns } from "./super_home.vue?vue&type=template&id=2e8e168c&scoped=true&"
import script from "./super_home.vue?vue&type=script&lang=js&"
export * from "./super_home.vue?vue&type=script&lang=js&"
import style0 from "./super_home.vue?vue&type=style&index=0&id=2e8e168c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e168c",
  null
  
)

export default component.exports